export const BASE_URL = "https://us-central1-rbegc-223ce.cloudfunctions.net";
export const PROTOCOL_STATUS = {
  AWAITING_ANSWER: "Aguardando Resposta",
  ANSWERED: "Respondido",
};
